import { connect } from 'react-redux';

import WithDefaults from '../WithDefaults';
import BatchPhysicalLocation from '../../Components/BatchPhysicalLocation';

import {
  batchXlsxUpload,
  getBatchStatus,
  submitBatch
} from '../../reducers/physicalLocation';

const mapStateToProps = (state, ownProps) => ({
  ...ownProps
});

const mapDispatchToProps = (dispatch) => ({
  batchXlsxUpload(...args) {
    return batchXlsxUpload(dispatch, ...args);
  },
  getValidationStatus(...args) {
    return getBatchStatus(dispatch, 'batchValidation', ...args);
  },
  submitBatch(...args) {
    return submitBatch(dispatch, ...args);
  },
  getSubmissionStatus(...args) {
    return getBatchStatus(dispatch, 'batchUpsert', ...args);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(WithDefaults(BatchPhysicalLocation));
